// Public cast data must come from videos, never the complete private CRM directory.
const asList = (value) => Array.isArray(value) ? value : [];
const handle = (value = "") => String(value).trim()
  .replace(/^https?:\/\/(?:www\.)?(?:x|twitter)\.com\//i, "")
  .replace(/^@/, "").split(/[/?#]/)[0].toLowerCase();

export const castSlug = (person) => encodeURIComponent(
  String(person.slug || person.stage_name || person.name || person.id || "")
    .trim().toLowerCase().replace(/\s+/g, "-")
);

export function videoCast(video) {
  const people = [
    ...asList(video?.cast), ...asList(video?.models), ...asList(video?.performers),
    ...asList(video?.cast_crew).filter((person) => !person?.role || /model|performer|talent|actor/i.test(person.role)),
  ];
  return dedupeVideoCast(people);
}

export function dedupeVideoCast(people) {
  const entries = [];
  for (const raw of people || []) {
    if (!raw || typeof raw !== "object") continue;
    const name = raw.stage_name || raw.name || raw.display_name;
    if (!name) continue;
    const person = {
      ...raw, name, stage_name: name,
      photo: raw.photo || raw.image || raw.avatar || raw.avatar_url || raw.profile_pic_url || raw.photo_url,
      twitter: raw.twitter || raw.x || raw.x_handle || raw.twitter_handle,
    };
    const keys = [
      ...[raw.id, raw.person_id, raw.crm_id, raw.cast_id, raw.model_id].filter(Boolean).map((id) => `id:${id}`),
      ...(person.twitter ? [`x:${handle(person.twitter)}`] : []),
      `name:${String(name).replace(/^@/, "").trim().toLowerCase()}`,
    ];
    const matches = entries.filter((entry) => keys.some((key) => entry.keys.has(key)));
    if (!matches.length) {
      entries.push({ person, keys: new Set(keys) });
      continue;
    }
    const target = matches[0];
    for (const duplicate of [{ person, keys: new Set(keys) }, ...matches.slice(1)]) {
      for (const [key, value] of Object.entries(duplicate.person)) {
        if (!target.person[key] && value) target.person[key] = value;
      }
      duplicate.keys.forEach((key) => target.keys.add(key));
      if (duplicate !== matches[0] && entries.includes(duplicate)) entries.splice(entries.indexOf(duplicate), 1);
    }
  }
  return entries.map((entry) => entry.person);
}

export function socialUrl(value, network) {
  if (!value) return null;
  const socialNetwork = network === "twitter" ? "x" : network;
  const hosts = {
    x: /(^|\.)(x|twitter)\.com$/i,
    instagram: /(^|\.)instagram\.com$/i,
    onlyfans: /(^|\.)onlyfans\.com$/i,
  };
  const hostPattern = hosts[socialNetwork];
  if (!hostPattern) return null;
  const text = String(value).trim();
  if (/^https?:\/\//i.test(text)) {
    try {
      const url = new URL(text);
      return hostPattern.test(url.hostname) ? url.href : null;
    } catch { return null; }
  }
  const username = text.replace(/^@/, "");
  const domains = { x: "x.com", instagram: "instagram.com", onlyfans: "onlyfans.com" };
  return /^[a-z0-9_.]+$/i.test(username) ? `https://${domains[socialNetwork]}/${username}` : null;
}
